module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"add":"Add","label":"Price buckets","refresh":"Update list"}}')
  delete Component.options._Ctor
}
